<script setup lang="ts">
import { computed } from 'vue'
import { resolveImmiSrc } from '@/lib/immiIcons'

const props = defineProps<{ icon: string | null | undefined }>()

const src = computed(() => resolveImmiSrc(props.icon))
</script>

<template>
  <img
    v-if="src"
    :src="src"
    class="layout-menuitem-icon immi-icon"
    alt=""
    aria-hidden="true"
  />
  <i
    v-else-if="icon"
    :class="icon"
    class="layout-menuitem-icon"
    aria-hidden="true"
  />
</template>

<style scoped>
.immi-icon {
  width: 1.5rem;
  height: 1.5rem;
  object-fit: contain;
  flex-shrink: 0;
  filter: var(--immi-icon-filter, none);
}
</style>
